<template>
  <section class="details">
    <!--
    <article class="details-card">
      <header class="details-header">
        <h1 class="details-header--title">Faturas</h1>
        <p class="details-header--date">Altere o estado das faturas</p>
      </header>

      <invoice-table :root="true" :invoices="invoices" @update="update" />
    </article>
    -->

    <article class="details-card" style="margin-top: 32px">
      <header class="details-header">
        <h1 class="details-header--title">Usuários</h1>
        <p class="details-header--date">Veja seus usuários e adicione ou remova saldo</p>
      </header>

      <vue-good-table
        :columns="[
          {
            label: 'ID',
            field: 'id',
            type: 'number',
          },
          {
            label: 'Cadastrado em',
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'YYYY-MM-DD HH:mm:ss',
            dateOutputFormat: 'DD/MM/YY HH:mm',
          },
          {
            label: 'Nome',
            field: 'name',
          },
          {
            label: 'Email',
            field: 'email',
          },
          {
            label: 'País',
            field: 'country',
          },
          {
            label: 'Saldo',
            field: 'balance',
            searchable: false,
            type: 'number',
          },
          {
            label: 'Ações',
            field: 'actions',
            sortable: false,
          },
        ]"
        :rows="users"
        :search-options="{
          enabled: true,
          placeholder: 'Pesquisar',
        }"
        :sort-options="{
          enabled: true,
          initialSortBy: {field: 'id', type: 'desc'}
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: 20,
          position: 'top',
          perPageDropdown: [10, 20, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Próximo',
          prevLabel: 'Anterior',
          rowsPerPageLabel: 'Resultados por página',
          ofLabel: 'of',
        }"
        >
        <template slot="table-row" slot-scope="props">
          <template v-if="props.column.field == 'actions'">
            <button @click.prevent="balance(props.row.id)">Adicionar / Remover créditos</button>
          </template>
          <template v-else>
            {{ props.formattedRow[props.column.field] }}
          </template>
        </template>
      </vue-good-table>
    </article>
  </section>
</template>

<script>
  import Axios from 'core/axios';
  import store from 'core/store';
  import InvoiceTable from '@/Invoice/Table';

  export default {
    components: {
      InvoiceTable,
    },

    created () {
      this.fetch();
    },

    data: () => ({
      invoices: [],
      users: [],
    }),

    beforeRouteEnter (to, from, next) {
      if (store.getters['auth/root']) {
        next();
      } else {
        next('/');
      }
    },

    methods: {
      fetch () {
        Axios.get('user')
          .then(({ data }) => this.users = data.data);
      },

      balance (id) {
        const value = Number(window.prompt('Coloque o total de créditos. Para remover, digite um número negativo.', 0));

        if (value === 0 || ! Number.isInteger(value)) {
          return;
        }

        const user = this.users.find(user => user.id == id);

        user.balance += value;

        Axios.post('admin/balance', {
          id,
          value,
        })
        .catch(() => user.balance -= value);
      },

      update (id, currentStatus) {
        const status = currentStatus == 'paid' ? 'refunded' : 'paid';

        Axios.put('admin/invoice/' + id, {
          status,
        })
        .then(() => this.invoices.find(invoice => invoice.id == id).status = status);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Admin/Admin.vue